import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AddressFields } from '@/components/AddressFields/AddressFields';
import { Button } from '@/components/Button/Button';
import { Input } from '@/components/Input/Input';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
// Modules
import { config } from '@/lib/config';
import { log } from '@/lib/log';
import { validateInputs } from '@/lib/validator';

const addressSelector = false;

/**
 *
 * @param {*} props
 * @returns {ReactElement}
 */
const Address = () => {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [sameAddress, toggleAddress] = useState(true);

  useEffect(() => {
    const sessionState = JSON.parse(sessionStorage.getItem('sessionData') ?? '');

    if (sessionState) {
      dispatch({
        type: ActionTypes.restoreFromStorage,
        payload: sessionState
      });
    }

    // if (state?.bundle?.containsPhysical) {
    // navigate("/bezahlen");
    // }
  }, [dispatch]);

  /**
   *
   * @param {*} event
   */
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    validateInputs();

    log('Change route to', config.routes.payment);
    navigate(config.routes.payment);
  }

  return (
    <>
      <h1>Zustellung / Anschrift</h1>
      <p>Bitte geben Sie die gewünschte Lieferadresse an.</p>

      <form onSubmit={handleSubmit}>
        <fieldset disabled={state.disableOnSubmit}>
          <AddressFields key="delivery" />

          {addressSelector ? (
            <div className="inline-flex fx-50">
              <label>
                <Input
                  checked={sameAddress ? true : false}
                  id="shippingAddressSelector1"
                  name="shippingAddressSelector"
                  onChange={() => toggleAddress(true)}
                  type="radio"
                />
                Lieferadresse ist gleich Rechnungsadresse
              </label>

              <label>
                <Input
                  id="shippingAddressSelector2"
                  name="shippingAddressSelector"
                  onChange={() => toggleAddress(false)}
                  type="radio"
                />
                Andere Lieferadresse
              </label>
            </div>
          ) : null}

          {sameAddress ? null : <AddressFields key="shipping" />}

          <div className="actions">
            <Button
              ariaLabel="Weiter zur Zahlung"
              className="form--button-cta"
              disabled={state.disableOnSubmit}
              type="submit"
            >
              Weiter zur Zahlung
            </Button>
          </div>
        </fieldset>
      </form>
    </>
  );
};

export { Address };
